export default "__VITE_ASSET__CKZPAXET__"